
import React from "react";

const CoursesBenefits = () => (
  <section className="section-padding bg-kaija-light">
    <div className="container-custom">
      <div className="max-w-3xl mx-auto text-center mb-12">
        <h2 className="text-2xl md:text-3xl font-medium mb-6">Miks valida meie kursused?</h2>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        <div className="bg-white p-6 rounded-lg shadow-sm">
          <h3 className="text-xl font-medium mb-3">Paindlikkus</h3>
          <p className="text-gray-700">
            Õpi omas tempos ja endale sobival ajal. Juurdepääs kursusele on eluaegne.
          </p>
        </div>
        <div className="bg-white p-6 rounded-lg shadow-sm">
          <h3 className="text-xl font-medium mb-3">Praktilised oskused</h3>
          <p className="text-gray-700">
            Iga kursus sisaldab praktilisi harjutusi ja ülesandeid, mida saad kohe rakendada.
          </p>
        </div>
        <div className="bg-white p-6 rounded-lg shadow-sm">
          <h3 className="text-xl font-medium mb-3">Ekspertteadmised</h3>
          <p className="text-gray-700">
            Kursused on loodud erialaste ekspertide poolt, kes jagavad oma kogemusi ja teadmisi.
          </p>
        </div>
      </div>
    </div>
  </section>
);

export default CoursesBenefits;
